import Vue from 'vue';
import geMenu from './ge-menu';

Vue.component('ge-menu', geMenu);

export default geMenu;



// WEBPACK FOOTER //
// ./scripts/ge-menu/index.js